import Service from '../../../service/api';

const v4Data = {
  namespaced: true,
  state: {v4SaveContentStatus: {}, v4ScoreResult: {}, v4SaveScoreResult: {}},
  mutations: {
    stampCurrentMainCodeItem(state, data) {
      console.log('stamp current v4-data', data);
      state.v4SaveContentStatus = {response: data};
      // console.log(state.v4SaveContentStatus, 'state');
    },
    scoreResultv4(state, data) {
      state.v4ScoreResult = data;
    },
    saveScoreOnlyv4(state, data) {
      state.v4SaveScoreResult = {response: data};
    },
  },
  actions: {
    getScoreResultv4({commit, dispatch, state}, payload) {
      //get stack payload
      //loop score and max score to make new obj
      let totalScore = 0;
      let totalMaxScore = 0;

      for (let i = 0; i < payload.length; i++) {
        const item = payload[i];
        if (
          typeof item.score === 'number' &&
          typeof item.maxScore === 'number'
        ) {
          totalScore += item.score;
          totalMaxScore += item.maxScore;
        }
      }
      //send to mutation
      commit('scoreResultv4', {score: totalScore, maxScore: totalMaxScore});
      //send to getter
    },
  },
  getters: {
    saveContentStatusv4(state) {
      // console.log('getter call', state.v4SaveContentStatus);

      return state.v4SaveContentStatus;
    },
    getScoreResultv4(state) {
      return state.v4ScoreResult;
    },
    getSaveScoreResultv4(state) {
      return state.v4SaveScoreResult;
    },
  },
};

export default v4Data;
